/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

export const PERMISSIONS = {
  CONTACTS_READ: "read:contacts",
  CONTACT_AUDIO_READ: "read:audio-contact",
  IMPORTS_READ: "read:imports",
  IMPORT_CREATE: "create:import",
  INSIGHTS_READ: "read:insights",
  PROMPTS_READ: "read:prompts",
  PROMPT_CREATE: "create:prompt",
  PROMPT_UPDATE: "update:prompt",
  PUBLISH_PROMPT_CREATE: "create:publish-prompt",
  RATINGS_READ: "read:ratings",
  RATING_PROMPT_CREATE: "create:prompt-rating",
  SETTINGS_READ: "read:settings",
  SETTINGS_UPDATE: "update:settings",
  TRUSSTED_AGENT_READ: "read:trusstedagent",
  TRUSSTED_AGENT_UPDATE: "update:trusstedagent",
  TRUSSTED_AGENT_CREATE: "create:trusstedagent",
  TRUSSTED_AGENT_DELETE: "delete:trusstedagent",
  WIDGET_CREATE: "create:widget",
  WIDGET_DELETE: "delete:widget",
} as const;
